import React from 'react'
import bannerImage from '../../../assets/images/banner-cars-in-africa.jpg'
import Image from '../../atoms/Image/Image'
import { Col, Container, Row } from 'react-bootstrap'
import Tabs from '../../atoms/Tabs/Tabs'
// import CabServiceSearch from '../PickupDropSearch/CabServiceSearch'

const HeroSection = () => {
  return (
    <>
        <section className="hero-section">
            <figure className='mb-0 hero-section--item-image'><Image src={bannerImage} alt="slider"  width="1920" height="650px" /></figure>
            <div className="hero-section--item-content ">
                <Container>
                    {/* <Row className='mb-4'>
                        <Col className='col-12 col-lg-5'>
                            <h1 className="hero-section--item-content--h1 h1 mb-0">Looking for a vehicle? You’re at the right place.</h1>    
                        </Col>
                    </Row> */}
                    <Row>
                        <Col className='col-12'>
                            <Tabs />
                            {/* <CabServiceSearch /> */}
                        </Col>
                    </Row>
                </Container>
            </div>
        </section>
    </>
  )
}

export default HeroSection
